module.exports = __webpack_public_path__ + "frontend/images/agents/provide-appliances-b893229ea38feec94f7dec0f8ad3a9fb.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/provide-appliances.png
// module id = 361
// module chunks = 2